<template>
  <div class="container detail-shell page-title-area px-4">
    <header class="mt-5">
      <div class="title flex flex-wrap items-center gap-2">
        <FormButton
          type="light" :isIcon="true"
          @click="goBack"
          class="text-dark-7 mr-2 md:mr-4 p-1"
        >
          <icon-base :width="6" :height="12" class="mr-2" width-view-box="8" height-view-box="14" fill="none"><icon-chevron-left-thin /></icon-base>
        </FormButton>
        <h2 class="page-title m-0 min-w-0">Manage Tags</h2>
        <FormButton size="md" class="w-full justify-center sm:ml-auto sm:w-auto" type="main" @click="$showModal('1-modal')">
          <icon-base class="ml-2" :width="20" :height="20" fill="none"><icon-plus-cross /></icon-base>
          New Tag
        </FormButton>
      </div>
    </header>
    <section class="">
      <ul class="tag-list list-group-flush mt-4">
        <li class="flex gap-0 items-center px-0 tag-list__header">
          <div class="text-dark-6 text-s-s w-1/6 lg:w-1/12">Color</div>
          <div class="text-dark-6 text-s-s w-2/3 lg:w-3/4">Name</div>
          <div class="text-dark-6 text-s-s w-1/6"></div>
        </li>
        <div v-if="this.generalTags.length === 0" class="text-center mt-5">
          <p class="text-s-xl text-dark-9 mb-1">No tags added yet</p>
          <p class="text-s-m text-dark-6">Add a new tag to get started</p>
        </div>
        <li v-for="(tag, index) in generalTags" :key="tag.id || tag.title" class="flex gap-0 items-center px-0 tag-list__item py-2 min-w-0">
          <div class="w-1/6 lg:w-1/12">
            <drop-down-menu 
              type="link" customClasses="rounded-pill p-0" listClasses="dropdown-menu_md mt-0"
            >
              <template #toggle-button>
                <span class="tag-color bordered" :class="tag.color"></span>
              </template>

              <template #menu-items>
              <drop-down-menu-item is-text>
                Choose a color
              </drop-down-menu-item>
              <drop-down-menu-item is-custom>
                <div class="flex flex-wrap">
                  <FormButton type="light" :isIcon="true" class="tag-color tag-color_action mr-3 mb-3 p-0" @click="changeTagColor(color, tag)" v-for="color in colorsList" :key="color.name" :class="color.name"></FormButton>
                </div>
              </drop-down-menu-item>
              </template>
            </drop-down-menu>
          </div>
          <div class="flex min-w-0 w-2/3 lg:w-3/4">
            <span contenteditable @input="onInput(tag.title, index)" :ref="'tag' + index" class="min-w-0 text-dark-9 px-3 -mx-3 text-capitalize text-s-m" @keydown.enter.prevent="preventEnter">{{tag.title}}</span>
            <FormButton type="main" class="ml-4 hidden md:inline-flex btn-tag-save" size="sm" @click="changeTagName(tag, index)">Save</FormButton>
            <FormButton type="secondary" class="ml-2 hidden md:inline-flex btn-tag-cancel" size="sm" @click="resetTagName(tag, index)">Cancel</FormButton>
          </div>
          <div class="text-right w-1/6">
            <FormButton ref="deleteTag" type="light" :isIcon="true" size="sm" class="p-1 btn-tag-delete hidden md:inline-flex" @click="showDeleteModal(tag, index)">
              <icon-base :width="20" :height="20" fill="none"><icon-trash-outline /></icon-base>
            </FormButton>
            <drop-down-menu listClasses="dropdown-menu_md" 
              right 
              type="light" :isIcon="true"
              size="sm" customClasses="pr-1 pl-1" 
              class="md:hidden">
              <template #toggle-button>
                <img src="@/assets/icons/settings.svg" alt="Settings">
              </template>

              <template #menu-items>
              <drop-down-menu-item @click="changeTagName(tag, index)" customClasses="">   
                <span>Save</span>
              </drop-down-menu-item>
              <drop-down-menu-item @click="resetTagName(tag, index)" customClasses="">
                <span>Cancel</span>
              </drop-down-menu-item>
              <drop-down-menu-item @click="showDeleteModal(tag, index)" type="delete">  
                <span>Delete</span>
              </drop-down-menu-item>
              </template>
            </drop-down-menu>
          </div>
        </li>
      </ul>
      <ModalBox v-model="legacyModalVisible" size="sm" hide-close header-class="!hidden" wrapper-classes="lg:h-auto lg:max-h-none p-6">
        <h4 class="text-500 text-s-xl text-left">Are yousure you want to delete the "<span class="prevent-overflow">{{ deleteName }}</span>" tag?</h4>
        <p class="text-s-l text-dark-8 mb-4">We’ll remove this tags from your files.</p>
        <div class="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <FormButton
            size="md"
            type="secondary"
            class="w-full justify-center sm:mr-2 sm:w-auto"
            @click="hideLegacyModal()"
          >
            Cancel
          </FormButton>
          <FormButton
            size="md"
            type="danger"
            class="w-full justify-center sm:w-auto"
            @click="deleteTag()"
          >
            Delete
          </FormButton>
        </div>
      </ModalBox>
      <AddTagModal
        :video-id="1"
        :video-tags="generalTags" 
      />
    </section>
  </div>
</template>

<script>
import { showModal, hideModal } from '@/Utils/modalBus'
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import AddTagModal from '@/components/modals/AddTagModal.vue'; 
import FormButton from '@/components/Atoms/FormButton.vue';
import DropDownMenu from '@/components/Atoms/DropDownMenu.vue'
import DropDownMenuItem from '@/components/Atoms/DropDownMenuItem.vue'
import IconBase from '@/components/icon/IconBase.vue'
import IconChevronLeftThin from '@/components/icon/IconChevronLeftThin.vue'
import IconPlusCross from '@/components/icon/IconPlusCross.vue'
import IconTrashOutline from '@/components/icon/IconTrashOutline.vue'

export default {
  name: "VODTagsManage",
  mixins: [legacyModalBridgeMixin],
  components: {
		ModalBox,
    DropDownMenu,
    DropDownMenuItem,
    FormButton,
    AddTagModal,
    IconBase,
    IconChevronLeftThin,
    IconPlusCross,
    IconTrashOutline,
	},
  data() {
    return {
      colorsList: [
        {name: 'color-1'},
        {name: 'color-2'},
        {name: 'color-3'},
        {name: 'color-4'},
        {name: 'color-5'},
        {name: 'color-6'},
        {name: 'color-7'},
        {name: 'color-8'},
        {name: 'color-9'},
      ],
      deleteName: null,
      deleteTagTarget: null,
    };
  },
  computed: {
    legacyModalId() {
      return 'modal-delete-tag';
    },
    generalTags() {
      return this.$store.state.Ui.tags;
    }
  },
  methods: {
    onInput(tag, index) {
      const messageError = 'The Tag Name should not contain more than 50 characters';
      // console.log(tag);
      // console.log(this.$refs['tag' + index][0].innerHTML)
      if (this.$refs['tag' + index][0].innerHTML.length > 50) {
        this.$notify({ group: 'error', text: messageError });
        this.$refs['tag' + index][0].innerHTML = tag
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    changeTagColor(color, tag) {
			this.$store.dispatch('Ui/changeTagColor', {color, tag})
      const messageSuccess = 'The color of the <span class="text-capitalize">' + tag.title + '</span> was changed';
      this.$notify({ group: 'success', text: messageSuccess });
		},
    changeTagName(tag, index) {
      const newTagName = this.$refs['tag' + index][0].innerHTML;
      const messageSuccess = 'The name of the <span class="text-capitalize">' + tag.title + '</span> was changed';
      const messageError = 'The <span class="text-capitalize">' + newTagName + '</span> tag name is already exists. Please choose a different one.';
      
      let generalTags = this.$store.state.Ui.tags;
      let existingTag = generalTags.find((generalTag => generalTag.title.toLowerCase() == newTagName.toLowerCase()));
      if (newTagName.length == 0) {
        this.$notify({ group: 'error', text: 'Tag name cannot be empty' });
        this.$refs['tag' + index][0].innerHTML = tag.title;
      } else if (existingTag && newTagName != tag.title) {
        this.$notify({ group: 'error', text: messageError });
        this.$refs['tag' + index][0].innerHTML = tag.title;
      } else if (newTagName != tag.title) {
        this.$store.dispatch('Ui/changeTagName', {newTagName, tag});
        this.$notify({ group: 'success', text: messageSuccess });
      }
    },
    resetTagName(tag, index) {
      this.$refs['tag' + index][0].innerHTML = tag.title;
    },
    showDeleteModal(tag) {
      this.deleteName = tag.title;
      this.deleteTagTarget = tag;
      showModal('modal-delete-tag');
    },
    deleteTag() {
      const tag = this.deleteTagTarget;
      if (!tag) return;
      this.$store.dispatch('Ui/deleteTag', tag);
      this.hideLegacyModal();
      this.deleteTagTarget = null;
      const messageSuccess = 'The <span class="text-capitalize">' + tag.title + '</span> was successfully deleted';
      this.$notify({ group: 'success', text: messageSuccess });
    },
    preventEnter(e) {
			e.preventDefault();
		}
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
:deep(.tags-header header) {
  color: var(--c-dark-8);
  font-size: var(--font-s-m);
}
.tag-list__item:hover {
  background-color: var(--c-dark-2);
}
.btn-tag-delete {
  color: var(--c-dark-6);
  opacity: 0;
}
.btn-tag-save, .btn-tag-cancel {
  opacity: 0;
}
.tag-list__item:hover .btn-tag-delete, .tag-list__item:active .btn-tag-delete, .tag-list__item:focus .btn-tag-delete, .tag-list__item:hover .btn-tag-save, .tag-list__item:hover .btn-tag-cancel {
  opacity: 1;
}
.tag-color_action {
  position: relative;
}
.tag-color_action:after {
  content: '';
  display: block;
  border-radius: 13px;
  height: 26px;
  width: 26px;
  border: 2px solid var(--c-dark-6);
  position: absolute;
  top: -4px;
  left: -4px;
  opacity: 0;
  transition: .3s;
}
.tag-color:hover:after {
  opacity: 1;
  transition: .3s;
}
.tag-color_action:active:after {
  border-color: #fff;
  
}
.list-group-item [contenteditable] {
  display: inline-block;
  border-radius: 6px;
  border: 2px solid transparent;
  outline: 0px solid transparent;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-group-item [contenteditable]:hover {
  background-color: var(--c-dark-1);
}
.list-group-item [contenteditable]:focus {
  box-sizing: border-box;
  border: 2px solid var(--c-main-light);
}
.list-group-item [contenteditable]:focus + .btn-tag-save, .list-group-item [contenteditable]:active + .btn-tag-save, .list-group-item [contenteditable]:focus + .btn-tag-cancel, .list-group-item [contenteditable]:active + .btn-tag-cancel {
  opacity: 1;
}
.prevent-overflow {
  overflow-wrap: break-word;
}
</style>
